  <video style="width:100%; height:100%; background-color: #000000; display: block;" controls>
    <source src={{data.videoLink}} type="video/mp4">
  </video>